import AbhayaLibreRegular from 'assets/resumeBuilder/fonts/AbhayaLibre-Regular.ttf';
import ArchivoRegular from 'assets/resumeBuilder/fonts/Archivo-Regular.ttf';
import BebasNeueRegular from 'assets/resumeBuilder/fonts/BebasNeue-Regular.ttf';
import DMSansMedium from 'assets/resumeBuilder/fonts/DMSans-Medium.ttf';
import DMSansRegular from 'assets/resumeBuilder/fonts/DMSans-Regular.ttf';
import InterBold from 'assets/resumeBuilder/fonts/Inter-Bold.ttf';
import InterMedium from 'assets/resumeBuilder/fonts/Inter-Medium.ttf';
import InterRegular from 'assets/resumeBuilder/fonts/Inter-Regular.ttf';
import InterSemiBold from 'assets/resumeBuilder/fonts/Inter-SemiBold.ttf';
import OutfitBold from 'assets/resumeBuilder/fonts/Outfit-Bold.ttf';
import OutfitMedium from 'assets/resumeBuilder/fonts/Outfit-Medium.ttf';
import OutfitRegular from 'assets/resumeBuilder/fonts/Outfit-Regular.ttf';
import OutfitSemiBold from 'assets/resumeBuilder/fonts/Outfit-SemiBold.ttf';
import PoppinsBold from 'assets/resumeBuilder/fonts/Poppins-Bold.ttf';
import PoppinsMedium from 'assets/resumeBuilder/fonts/Poppins-Medium.ttf';
import PoppinsRegular from 'assets/resumeBuilder/fonts/Poppins-Regular.ttf';
import PoppinsSemiBold from 'assets/resumeBuilder/fonts/Poppins-SemiBold.ttf';
import LatoLight from 'assets/resumeBuilder/fonts/Lato-Light.ttf';
import LatoRegular from 'assets/resumeBuilder/fonts/Lato-Regular.ttf';
import LatoBold from 'assets/resumeBuilder/fonts/Lato-Bold.ttf';
import RobotoRegular from 'assets/resumeBuilder/fonts/Roboto-Regular.ttf';
import RobotoMedium from 'assets/resumeBuilder/fonts/Roboto-Medium.ttf';
import RobotoBold from 'assets/resumeBuilder/fonts/Roboto-Bold.ttf';
import Stangith from 'assets/resumeBuilder/fonts/stangith.ttf';

export const FONT_PATHS = {
	OutfitRegular,
	OutfitMedium,
	OutfitSemiBold,
	OutfitBold,
	DMSansRegular,
	DMSansMedium,
	BebasNeueRegular,
	ArchivoRegular,
	PoppinsRegular,
	PoppinsMedium,
	PoppinsSemiBold,
	PoppinsBold,
	InterRegular,
	InterMedium,
	InterSemiBold,
	InterBold,
	AbhayaLibreRegular,
	LatoLight,
	LatoRegular,
	LatoBold,
	RobotoRegular,
	RobotoMedium,
	RobotoBold,
	Stangith,
};
